<template>
	<v-row class="result-display" no-gutters>
		<v-col cols="12">
			<div class="sortition-name">{{ result.sortition.name }}</div>
			<span class="sortition-date">{{ result.date }}</span>
			<v-row no-gutters>
				<v-col
					class="d-flex flex-sm-column align-center justify-space-around"
					md="2"
				>
					<div class="first" v-if="result.first">
						<h1 class="header">1st</h1>
						<result-digit-display
							single
							:value="result.first"
						></result-digit-display>
					</div>
					<div class="second" v-if="result.second">
						<h1 class="header">2nd</h1>
						<result-digit-display
							single
							:value="result.second"
						></result-digit-display>
					</div>
					<div class="third" v-if="result.third">
						<h1 class="header">3rd</h1>
						<result-digit-display
							single
							:value="result.third"
						></result-digit-display>
					</div>
				</v-col>
				<v-col md="10">
					<v-row v-if="result.pickTwo" no-gutters align="center">
						<v-col sm="4">
							<v-img height="65" contain :src="require('assets/static/img/picks/lucklotto/pick2.png')" />
						</v-col>
						<v-col sm="8">
							<result-digit-display
								class="d-flex justify-center"
								:value="result.pickTwo"
							></result-digit-display>
						</v-col>
					</v-row>
					<v-row v-if="result.cashThree" no-gutters align="center">
						<v-col sm="4">
							<v-img height="65" class="pick-image" contain
							:src="require('assets/static/img/picks/lucklotto/pick3.png')"/>
						</v-col>
						<v-col sm="8">
							<result-digit-display
								class="d-flex justify-center"
								:value="result.cashThree"
							></result-digit-display>
						</v-col>
					</v-row>
					<v-row v-if="result.pickFour" no-gutters align="center">
						<v-col sm="4">
							<v-img height="65" class="pick-image" contain
							:src="require('assets/static/img/picks/lucklotto/pick4.png')"
							/>
						</v-col>
						<v-col sm="8">
							<result-digit-display
								class="d-flex justify-center flex-wrap"
								:value="result.pickFour"
								:group="2"
							></result-digit-display>
						</v-col>
					</v-row>
					<v-row v-if="result.pickFive" no-gutters align="center">
						<v-col sm="4">
							<v-img height="65" class="pick-image" contain
							:src="require('assets/static/img/picks/lucklotto/pick5.png')"
							/>
						</v-col>
						<v-col sm="8">
							<result-digit-display
								class="d-flex justify-center flex-wrap"
								:value="result.pickFive"
								:group="3"
							></result-digit-display>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import ResultDigitDisplay from './ResultDigitDisplay.vue';

export default {
	name: 'ResultDisplay',
	components: { ResultDigitDisplay },
	props: {
		result: {
			type: Object,
			required: true
		}
	}
};
</script>
<style scoped lang="scss">
.sortition-name {
	line-height: 25px;
	font-size: 1.5rem;
	font-weight: bold;
	margin-top: 3px;
}

.sortition-date {
	font-size: 1.2rem;
}

.result-display {
	padding: 0;
}

.first,
.second,
.third {
	display: flex;
	flex-direction: column;
	margin: 5px 0;

	.header {
		margin-bottom: 5px;
	}
}
</style>
